export const Paths = {
    local: [
        { key: "me", path: "/users/me.json" },
        { key: "serviceproviders", path: "/providers/serviceproviders.json" },
        { key: "serviceprovider", path: "/providers/serviceprovider.json" },
        { key: "contentproviders", path: "/providers/contentproviders.json" },
        { key: "contentprovider", path: "/providers/contentprovider.json" },
        { key: "programcontents", path: "/content/programcontents.json" },
        { key: "programcontent", path: "/content/programcontent.json" },
        { key: "programcontenttypes", path: "/content/programcontenttypes.json" },
        { key: "programcontenttype", path: "/content/programcontenttype.json" },
        { key: "contextualcontents", path: "/content/contextualcontents.json" },
        { key: "contextualcontent", path: "/content/contextualcontent.json" },
        { key: "contentbytype", path: "/content/programcontentsbytype.json" },
        { key: "assets", path: "/assets/assets.json" },
        { key: "asset", path: "/assets/asset.json" },
        { key: "ios", path: "/assets/ios.json" },
        { key: "android", path: "/assets/android.json" },
        { key: "anumbergroups", path: "/anumbers/anumbergroups.json" },
        { key: "anumbergroup", path: "/anumbers/anumbergroup.json" },
        { key: "anumbergroupmembers", path: "/anumbers/members.json" },
        { key: "assignments", path: "/anumbers/anumberassignments.json" },
        { key: "assignment", path: "/anumbers/anumber.json" },
        { key: "unscopedserviceaccounts", path: "/serviceaccounts/serviceaccounts.json" },
        { key: "unscopedservicekeys", path: "/users/keys.json" },
        { key: "scopedserviceaccounts", path: "/serviceaccounts/serviceaccounts.json" },
        { key: "scopedserviceaccount", path: "/serviceaccounts/serviceaccount.json" },
        { key: "scopedservicekeys", path: "/users/keys.json" },
        { key: "unscopedusers", path: "/users/users.json" },
        { key: "scopedusers", path: "/users/uusers.json" },
        { key: "unscopeduser", path: "/users/user.json" },
        { key: "cpscopedusers", path: "/users/uusers.json" },
        { key: "anumbers", path: "/anumbers/anumbers.json" },
        { key: "anumber", path: "/anumbers/anumber.json" },
        { key: "massupload", path: "/anumbers/massanumberupload.json" },
        { key: "massanumberupload", path: "/anumbers/anumbergroupmembers.json" },
    ],
    apis: [
        { key: "me", path: "/auth/v2/users/me" },
        { key: "serviceproviders", path: "/content/v2/serviceproviders" },
        { key: "serviceprovider", path: "/content/v2/serviceproviders/detail" },
        { key: "contentproviders", path: "/content/v2/contentproviders" },
        { key: "contentprovider", path: "/content/v2/contentproviders/detail" },
        { key: "programcontents", path: "/content/v2/programcontents" },
        { key: "programcontent", path: "/content/v2/programcontents/detail" },
        { key: "programcontenttypes", path: "/content/v2/programcontenttypes" },
        { key: "programcontenttype", path: "/content/v2/programcontenttypes/detail" },
        { key: "contextualcontent", path: "/content/v2/contextualcontents/detail" },
        { key: "contextualcontents", path: "/content/v2/contextualcontents" },
        { key: "validinformprograms", path: "/content/v2/validInformPrograms" },
        { key: "assets", path: "/content/v2/assets" },
        { key: "asset", path: "/content/v2/assets/detail" },
        { key: "ios", path: "/content/v2/assets/content/ios" },
        { key: "android", path: "/content/v2/assets/content/android" },
        { key: "anumbergroups", path: "/content/v2/anumbergroups" },
        { key: "anumbergroup", path: "/content/v2/anumbergroups/detail" },
        { key: "anumbergroupmembers", path: "/content/v2/anumbergroups/members" },
        { key: "updatemembers", path: "/content/v2/anumbergroups/members/detail" },
        { key: "unscopedserviceaccounts", path: "/auth/v2/serviceaccounts" },
        { key: "unscopedserviceaccount", path: "/auth/v2/users/serviceaccounts/detail" },
        { key: "unscopedservicekeys", path: "/auth/v2/serviceaccounts/keys" },
        { key: "scopedserviceaccounts", path: "/auth/v2/serviceproviders/serviceaccounts" },
        { key: "scopedserviceaccount", path: "/auth/v2/users/serviceproviders/serviceaccounts/detail" },
        { key: "scopedservicekeys", path: "/auth/v2/serviceproviders/serviceaccounts/keys" },
        { key: "unscopedusers", path: "/auth/v2/users" },
        { key: "unscopeduser", path: "/auth/v2/users/detail" },
        { key: "scopedusers", path: "/auth/v2/serviceproviders/users" },
        { key: "cpscopedusers", path: "/auth/v2/contentproviders/users" },
        { key: "cpscopeduser", path: "/auth/v2/contentproviders/users/detail" },
        { key: "scopeduser", path: "/auth/v2/serviceproviders/users/detail" },
        { key: "unscopedpolicy", path: "/content/v2/policies/detail" },
        { key: "scopedpolicy", path: "/content/v2/serviceproviders/policies/detail" },
        { key: "anumbers", path: "/content/v2/anumbers" },
        { key: "anumber", path: "/content/v2/anumbers/detail" },
        { key: "search", path: "/content/v2/anumbers/search" },
        { key: "anumberswithprogram", path: "/content/v2/anumbers/anumbersassignedtoprogram" },
        { key: "assignments", path: "/content/v2/anumberassignments" },
        { key: "assignment", path: "/content/v2/aNumberAssignments/aNumber" },
        { key: "massanumberupload", path: "/content/v2/aNumbers/upload" },
        { key: "anumbermassupdate", path: "/content/v2/anumbers/massupdate" },
        { key: "massuploadtocontentprovider", path: "/content/v2/anumbers/upload" },
        { key: "massanumberuploads", path: "/content/v2/massanumberhistory" },
        { key: "massanumberuploadrecord", path: "/content/v2/massanumberhistory/detail" },
        { key: "outbound", path: "/outbound/v2/programcontents/messages" },
        { key: "batch", path: "/outbound/v2/programcontents/batches" },
        { key: "call", path: "/api/demo/call" },
        { key: "portaltracking", path: "/content/v2/portaltracking" },
        { key: "notifications", path: "/content/v2/distributionNotificationMessages" },
        { key: "dashboardengagecalls", path: "/metric/v1/dashboard/engage/calls" },
        { key: "dashboardengageanswerrate", path: "/metric/v1/dashboard/engage/answerrate" },
        { key: "dashboardinformcalls", path: "/metric/v1/dashboard/inform/calls" },
        { key: "dashboardengagecontent", path: "/metric/v1/dashboard/engage/content" },
        { key: "dashboardinformcontent", path: "/metric/v1/dashboard/inform/content" },
        { key: "dashboardengagetotalpushes", path: "/metric/v1/dashboard/engage/totalpushes" },
        { key: "dashboardengagesuccesspushes", path: "/metric/v1/dashboard/engage/successpushes" },
        { key: "reporting", path: "/content/v2/qs/dashboard" },
    ],
};

export interface IEnvironmentSettings {
    getFixtureSettings(): any;
    getLiveSettings(): any;
}

export class EnvironmentSettings implements IEnvironmentSettings {
    public getFixtureSettings(): Array<any> {
        return Paths.local;
    }

    public getLiveSettings(): Array<any> {
        return Paths.apis;
    }
}
